import { render, staticRenderFns } from "./ViewOrderDocument.vue?vue&type=template&id=2fd4cc93&scoped=true&"
import script from "./ViewOrderDocument.vue?vue&type=script&lang=js&"
export * from "./ViewOrderDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd4cc93",
  null
  
)

export default component.exports